// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zyZ7","clinicsSelect":"styles_clinicsSelect__yKg3_"};